var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Toasts'),_c('transition',{attrs:{"name":"fade"}},[(_vm.panelCount > 0)?_c('div',{attrs:{"id":"overlay"},on:{"click":_vm.removeAllPanels}}):_vm._e()]),_c('Navigation'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }